import { render, staticRenderFns } from "./ModuleMatrix.vue?vue&type=template&id=dbe97364&scoped=true"
import script from "./ModuleMatrix.vue?vue&type=script&lang=js"
export * from "./ModuleMatrix.vue?vue&type=script&lang=js"
import style0 from "./ModuleMatrix.vue?vue&type=style&index=0&id=dbe97364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe97364",
  null
  
)

export default component.exports